import { useState } from "react";
import { faqs } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number[]>([0]);

  const toggle = (idx: number) => {
    setOpen((prev) => (prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]));
  };

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/60">
      <Reveal>
        <SectionHeading
          tag="常见问题"
          title="关于入口、地址与下载的高频疑问"
          desc="把大家最常问的问题集中整理，点开即可查看说明，不用再到处翻找答案。"
        />
      </Reveal>

      <Reveal delay={60}>
        <div className="mt-10 max-w-4xl space-y-3">
          {faqs.map((item, idx) => {
            const isOpen = open.includes(idx);
            return (
              <div
                key={idx}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-label shrink-0 mt-0.5">
                      Q
                    </span>
                    <span className="font-label font-medium text-foreground-900 text-sm md:text-base">
                      {item.q}
                    </span>
                  </span>
                  <span
                    className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-transform ${
                      isOpen ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                <div
                  className="grid transition-all duration-300 ease-out"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm text-foreground-700 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
}